import "./App.css";
import NavBar from "./toolComponents/NavBar/NavBar";
import Footer from "./toolComponents/Footer/Footer";
import Landing from "./pages/Landing/Landing";
import About from "./pages/About/About";
import Information from "./components/information";
import Career from "./pages/Career/Career";
import ServicesPage from "./pages/Services/ServicesPage";
import UploadArticle from "./pages/Upload_Articles/UploadArticle";
import ArticlesList from "./pages/ArticlesList/ArticlesList";
import ArticleGrid from "./pages/ArticleGrid/ArticleGrid";
import "@mantine/core/styles.css";
import { Route, Routes } from "react-router-dom";
import styled from "styled-components";
import "@mantine/core/styles.css";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import ArticleView from "./pages/ArticleView/ArticleView";
import UploadTestimonial from "./pages/UploadTestimonial/UploadTestimonial";
import Login from "./pages/Login/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import BlogSection from "./pages/Blogs/BlogSection";
import CryptoPayments from "./components/contactUs";
import SingleProject from "./components/SingleProject";
import ScrollToTop from "./ScrollToTop";
import UploadProject from "./pages/Upload_Projects/UploadProject";
import { MantineProvider } from "@mantine/core";
import Mortgage from "./pages/Landing/Mortgage";
import Team from "./components/Team";

const Container = styled.div`
  padding: 2rem;
`;

// const Pages = () => {
//   return (
//     <div>
//       <NavBar /> 
//       <ScrollToTop />
//       <Routes>
//         <Route path="/" element={<Landing />} />
//         <Route path="/contact" element={<CryptoPayments />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/projects" element={<Information main={true} />} />
//         <Route path="/projects/:id" element={<SingleProject />} />
//         <Route path="/services" element={<ServicesPage />} />
//         <Route path="/career" element={<Career />} />
//         <Route path="/blogs" element={<BlogSection />} />
//         <Route path="/privacypolicy" element={<PrivacyPolicy />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/uploadarticle" element={<ProtectedRoute><UploadArticle /></ProtectedRoute>}/>
//         <Route path="/upload-project" element={<ProtectedRoute><UploadProject /></ProtectedRoute>}/>
//         <Route path="/articleslist" element={<ArticlesList />} />
//         <Route path="/article/:id" element={<ArticleView />} />
//         <Route path="/articles" element={<ArticleGrid />} />
//         <Route
//           path="/uploadtestimonial"
//           element={
//             <ProtectedRoute>
//               <UploadTestimonial />
//             </ProtectedRoute>
//           }
//         />
//       </Routes>
//       <Footer />
//     </div>
//   );
// };

// function App() {
//   return (
//     <MantineProvider withGlobalStyles withNormalizeCSS>
//         <Pages />
//     </MantineProvider>
//   );
// } 
function App() {
  return (
    <MantineProvider withGlobalStyles withNormalizeCSS>
    <NavBar /> 
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/mortgage" element={<Mortgage />} />
        <Route path="/contact" element={<CryptoPayments />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Information main={true} />} />
        <Route path="/projects/:id" element={<SingleProject />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/career" element={<Career />} />
        <Route path="/blogs" element={<BlogSection />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/login" element={<Login />} />
        <Route path="/uploadarticle" element={<ProtectedRoute><UploadArticle /></ProtectedRoute>}/>
        <Route path="/upload-project" element={<ProtectedRoute><UploadProject /></ProtectedRoute>}/>
        <Route path="/articleslist" element={<ArticlesList />} />
        <Route path="/article/:id" element={<ArticleView />} />
        <Route path="/articles" element={<ArticleGrid />} />
        <Route path="/team" element={<Team />} />
        <Route
          path="/uploadtestimonial"
          element={
            <ProtectedRoute>
              <UploadTestimonial />
            </ProtectedRoute>
          }
        />
      </Routes>
      <Footer />
    </MantineProvider>
  );
}
export default App;
